module.exports = __webpack_public_path__ + "img/bg_video.dc314c88.jpg";